export default "__VITE_ASSET__DxohLEIb__"